import trackEventBase from '../helpers/trackEventBase';
/**
 * Exactly the same as trackEvent but in case of error it is a no op.
 * If you want to handle the error you can provide `onError` to the options variable.
 *
 * Please read this document before you implement any tracking to understand what DA's expect and why https://hmgroup.atlassian.net/wiki/spaces/BTCAEWVA/pages/687965161/Future+Commerce .
 *
 * @param method - Identical to {@link trackEvent}.
 * @param utagData - Identical to {@link trackEvent}.
 * @param options - Extends options of {@link trackEvent} with an `onError: (err) => void` function that you can provide if you want to handle the error.
 * @returns - Forwards the promise from {@link trackEvent} but handles the error using the provided `onError` function in `options`, or it just ignores the error.
 */
function safeTrackEvent(method, utagData, options) {
    return trackEventBase(method, utagData, options).catch((err) => {
        if (options === null || options === void 0 ? void 0 : options.onError) {
            options.onError(err);
        }
    });
}
export default safeTrackEvent;
//# sourceMappingURL=safeTrackEvent.js.map